import { TabsContent } from './TabsContent'
import { TabsRoot } from './TabsRoot'
import { useTabs } from './useTabs'

export const Tabs = {
  Root: TabsRoot,
  Content: TabsContent,
  store: useTabs,
}
